import type { PreviewAction } from "../../api/contracts";

export interface PreviewDay { date: string; staff: { staffId: string; staffName: string; actions: PreviewAction[] }[] }

export function groupPreview(actions: PreviewAction[]): PreviewDay[] {
  const days = new Map<string, Map<string, { staffId: string; staffName: string; actions: PreviewAction[] }>>();
  for (const a of actions) {
    const day = days.get(a.date) ?? new Map();
    days.set(a.date, day);
    const s = day.get(a.staffId) ?? { staffId: a.staffId, staffName: a.staffName, actions: [] };
    day.set(a.staffId, s);
    s.actions.push(a);
  }
  return [...days.entries()].sort(([x], [y]) => x.localeCompare(y)).map(([date, staff]) => ({
    date,
    staff: [...staff.values()].sort((x, y) => x.staffName.localeCompare(y.staffName))
      .map((s) => ({ ...s, actions: [...s.actions].sort((x, y) => (x.edge === y.edge ? 0 : x.edge === "start" ? -1 : 1)) })),
  }));
}

export const PLANNED_TONE: Record<PreviewAction["type"], "success" | "danger" | "info" | "neutral"> = { create: "success", remove: "danger", resize: "info", release: "neutral", lock: "info", adopt: "info", skip: "neutral" };

export const ACTION_LABEL: Record<PreviewAction["type"], string> = { create: "Add", remove: "Remove", resize: "Resize", release: "Left to staff", lock: "Lock as DNB", adopt: "Take over BTB", skip: "No change" };

export interface PreviewRow { key: string; staffName: string; first: boolean; action: PreviewAction }
/** A day's grouped actions as table rows; the name is only on a staff member's first row. */
export function flattenDay(day: PreviewDay): PreviewRow[] {
  return day.staff.flatMap((s) => s.actions.map((action, i) => ({ key: `${s.staffId}:${action.edge}:${i}`, staffName: s.staffName, first: i === 0, action })));
}
